// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UpdateItemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/update_item/{item_id}
 *
 * Update fields on an existing order item (partial update — all fields optional).
 *
 * Fields:
 *   qrcode               — string, optional
 *   service_priority_id  — int, optional (changes plan/price when present)
 *   additional_services  — int[], optional (so_additional_service IDs; replaces
 *                          existing children — see model updateServiceItem)
 *   products             — Orders_UpdateItemProductInputRow[], optional
 *                          (replaces existing product children)
 *   attributes           — Orders_OrderItemAttributeInputRow[], optional
 *                          (saved via replaceForOrderItem)
 */
import type { Orders_OrderItemAttributeInputRow } from './Orders_OrderItemAttributeInputRow'
import type { Orders_UpdateItemProductInputRow } from './Orders_UpdateItemProductInputRow'
import { registerContract } from './validate'

export interface Orders_UpdateItemInput {
qrcode?: string
service_priority_id?: number
additional_services?: unknown[]
products?: Orders_UpdateItemProductInputRow[]
attributes?: Orders_OrderItemAttributeInputRow[]
}

registerContract('Orders_UpdateItemInput', {
  qrcode:              { type: 'string',  required: false },
  service_priority_id: { type: 'number',  required: false },
  additional_services: { type: 'array',   required: false },
  products: {
    type: 'array',
    required: false,
    items: {
      product_id: { type: 'number',  required: true },
      quantity:   { type: 'number',  required: false },
    },
  },
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id: { type: 'number',  required: true },
      value:        { type: 'string',  required: false },
    },
  },
})
